import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTimeCycleGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M19.777 8.5H20a1 1 0 0 0 1-1V5a1 1 0 0 0-1.993-.122C15.881 1.84 10.927 1.072 7 3.34a1 1 0 1 0 1 1.732c3.213-1.856 7.314-1.156 9.8 1.428h-.3a1 1 0 1 0 0 2zM12 6a1 1 0 0 1 1 1v5.586l1.828 1.828a1 1 0 1 1-1.414 1.414l-2.121-2.12A1 1 0 0 1 11 13V7a1 1 0 0 1 1-1m-8.397.456a1 1 0 0 1 1.366.366l.09.157q.013.02.024.04l1.136 1.968a1 1 0 1 1-1.732 1l-.15-.26c-.995 3.445.45 7.346 3.663 9.201a1 1 0 1 1-1 1.732C3.073 18.393 1.26 13.72 2.328 9.492a1 1 0 0 1-.89-1.786zM21 11a1 1 0 0 1 1 1c0 4.535-3.142 8.441-7.336 9.63a1 1 0 0 1-1.102 1.664l-2.165-1.25a1 1 0 0 1-.366-1.366l.09-.157.024-.04 1.136-1.968a1 1 0 1 1 1.732 1l-.15.26C17.344 18.912 20 15.71 20 12a1 1 0 0 1 1-1'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTimeCycleGhost)
export default ForwardRef
